export default __webpack_public_path__ + "static/media/rectangles-no-6.e7bf9ce7.mid";